var PARTNERS_GRID_PARTNERS = window.PARTNERS_GRID.partners;
export { PARTNERS_GRID_PARTNERS };
